import { graphql } from 'src/graphql';

import type { ResultOf } from 'src/graphql';

export const TagFields = graphql(`
  fragment TagFields on TagType @_unmask {
    _id
    name
    color
  }
`);

export const TeamTags = graphql(
  `
    query TeamTags($teamId: ID!) {
      tags(filter: { _team_id: { eq: $teamId } }, first: 500, sort: { last_used: desc }) {
        nodes {
          ...TagFields
        }
      }
    }
  `,
  [TagFields],
);

export type TeamTag = ResultOf<typeof TagFields>;
